import { render, staticRenderFns } from "./TrainingView.vue?vue&type=template&id=74c2ded2&scoped=true&"
import script from "./TrainingView.vue?vue&type=script&lang=js&"
export * from "./TrainingView.vue?vue&type=script&lang=js&"
import style0 from "./TrainingView.vue?vue&type=style&index=0&id=74c2ded2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c2ded2",
  null
  
)

export default component.exports